import { render, staticRenderFns } from "./AdministratorsDetail.vue?vue&type=template&id=1c37bcba&"
import script from "./AdministratorsDetail.vue?vue&type=script&lang=js&"
export * from "./AdministratorsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports